import { useMultiAgentStore } from "@/stores/multiAgentStore";

function SafetyBanner({
  tone, title, body,
}: { tone: "err" | "warn"; title: string; body: React.ReactNode }) {
  const accent = tone === "err" ? "var(--ma-state-err)" : "var(--ma-state-warn)";
  return (
    <div
      className="ma-fade-up mx-auto"
      style={{
        maxWidth: "var(--ma-prose-max)",
        margin: "16px auto 0",
        padding: "12px 16px",
        borderRadius: "var(--ma-radius-md)",
        background: `color-mix(in oklab, ${accent} 12%, var(--ma-surface))`,
        boxShadow: `var(--ma-shadow-sm), inset 0 0 0 1px color-mix(in oklab, ${accent} 40%, transparent)`,
      }}
    >
      <div className="mb-1 flex items-center gap-2">
        <span className={`ma-dot ${tone === "err" ? "ma-dot--err" : "ma-dot--warn"}`} />
        <span style={{ fontSize: 13, fontWeight: 600, color: accent }}>{title}</span>
      </div>
      <div style={{ fontSize: 12, color: "var(--ma-text)", lineHeight: 1.5 }}>{body}</div>
    </div>
  );
}

export function ContractViolationBanner() {
  const v = useMultiAgentStore((s) => s.contractViolation);
  if (!v) return null;
  return (
    <SafetyBanner
      tone="warn"
      title={`Synth contract violated · ${v.lane}`}
      body={
        <>
          The synthesizer produced output that broke the lane contract.
          Treat the answer below with caution.
          {v.violations.length > 0 && (
            <ul className="mt-1 ml-4" style={{ listStyle: "disc" }}>
              {v.violations.map((s, i) => (
                <li key={i} style={{ marginTop: 2 }}>{s}</li>
              ))}
            </ul>
          )}
        </>
      }
    />
  );
}

export function AutoFixFailedBanner() {
  const v = useMultiAgentStore((s) => s.autoFixFailed);
  if (!v) return null;
  return (
    <SafetyBanner
      tone="warn"
      title="Auto-fix could not propose diffs"
      body={
        <>
          The structured patch path failed — no Apply button will appear.
          {v.reason && (
            <div className="mt-1" style={{ fontFamily: "ui-monospace, monospace", color: "var(--ma-text-muted)" }}>
              {v.reason}
            </div>
          )}
        </>
      }
    />
  );
}

export function NoEvidenceBanner() {
  const verifier = useMultiAgentStore((s) => s.verifier);
  if (!verifier?.noEvidence) return null;
  return (
    <SafetyBanner
      tone="err"
      title="Ungrounded answer"
      body="Zero org tools ran on this run — the answer below is the model's best guess, NOT a query against your org. Treat as speculation and re-ask with a more specific entity name to ground it."
    />
  );
}
